export const MAX_CONTENT_SIZE = 10;
